import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import Diversity3OutlinedIcon from '@mui/icons-material/Diversity3Outlined';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import BookOutlinedIcon from '@mui/icons-material/BookOutlined';
import { Redirect } from "react-router-dom";
import { AppBar, Box, IconButton, Menu, MenuItem } from '@mui/material';
import { useEffect, useState } from 'react';
import InactivityMeter from './inactivitymeter';
import { rcolor, registrationHeader } from '../../style2';

export default function NDReferralHeader(props) {
  const [redirect, setRedirect] = useState('');
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  useEffect(() => {
    setRedirect('');
  }, [props])

  if (redirect !== "")
    return <Redirect to={redirect} />

  return <>
    <AppBar style={{ position: "static", background: "#ffffff", boxshadow: "none", marginBottom: "30px" }}>
      <Box style={{ height: "90px", display: "flex", justifyContent: "bottom", alignItems: 'center' }}>

        <Box sx={{ flexGrow: 1 }}>
          <IconButton onClick={() => { setRedirect(`/referral/${props.orgCode}`) }} style={{ marginRight: "20px", marginLeft: "20px" }}><HomeOutlinedIcon style={{ fontSize: "3.5rem", color: "#115C70" }} /></IconButton>
          {props.isLoggedIn ? <IconButton onClick={() => { setRedirect(`/referral/patients/${props.orgCode}`) }} style={{ marginRight: "20px", marginLeft: "20px" }}><Diversity3OutlinedIcon style={{ fontSize: "3.5rem", fontWeight: "lighter", color: "#115C70" }} /></IconButton> : null}
        </Box>
        <Box component="img" sx={{...registrationHeader, height: "70px"}} src={props.logo ? props.logo : '../Logo_Option_1.svg'} alt='Referral App logo'></Box>
        <Box sx={{ flexGrow: 1, textAlign: "right" }}>
          {props.isLoggedIn ? <>
            <IconButton onClick={handleClick}
              id='profile-button'
              aria-controls={open ? 'profile-menu' : undefined}
              aria-haspopup="true"
              aria-expanded={open ? 'true' : undefined}
              style={{ marginRight: "20px", marginLeft: "20px" }}>
              <AccountCircleOutlinedIcon style={{ fontSize: "3.5rem", color: rcolor }} /></IconButton>
            <Menu
              id="profile-menu"
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                transformOrigin={{ vertical: "top", horizontal: "center", }} sx={{ top: 1 }}
              MenuListProps={{
                'aria-labelledby': 'profile-button',
              }} 
            >
              <MenuItem onClick={() => { setRedirect(`/referral/updateaccount/${props.orgCode}`); handleClose(); }}>Profile</MenuItem>
              <MenuItem onClick={() => { localStorage.clear(); setRedirect(`/referral/login/${props.orgCode}`) }}>Logout</MenuItem>
            </Menu>
          </> : null}

          <IconButton onClick={() => { setRedirect(`/referral/resources/${props.orgCode}`) }} style={{ marginRight: "20px", marginLeft: "20px" }}><BookOutlinedIcon style={{ fontSize: "3.5rem", fontWeight: "lighter", color: rcolor }} /></IconButton>
        </Box>
      </Box>
    </AppBar>
    {props.isLoggedIn ? <InactivityMeter loginurl={`/referral/login/${props.orgCode}`} /> : null}
  </>;
}